module.exports = __webpack_public_path__ + "img/node-plus-fill.010a5298.svg";